import type { IUserJSON } from 'external-api-types';
import _ from 'lodash';
import type { History } from 'history';
import { QueryStringParser } from '../modules/QueryStringParser';
import type { UrlParams } from '../reducers/global';
import type { CoreUser } from '../types/User';
import type { ThunkResult } from './types';
import type { ToastsActions } from './global/toasts';

export type GlobalActions =
    | ToastsActions
    | {
          type: 'INIT_GLOBAL_STORE';
          data: { history: History };
      }
    | {
          type: 'SET_AUTHENTICATED_USER';
          data: { user: IUserJSON | null; coreUser: CoreUser | null };
      }
    | {
          type: 'SET_URL_PARAMS';
          data: { urlParams: { [k: string]: string } };
      }
    | {
          type: 'SET_PAGE_TITLE';
          data: { pageTitle: string };
      };

export const initGlobalStore = (opts: { history: History }): GlobalActions => ({
    data: {
        history: opts.history
    },
    type: 'INIT_GLOBAL_STORE'
});

export const setAuthenticatedUser = (opts: { user: IUserJSON | null; coreUser: CoreUser | null }): GlobalActions => ({
    data: {
        user: opts.user,
        coreUser: opts.coreUser
    },
    type: 'SET_AUTHENTICATED_USER'
});

export const refreshUrlParams = (): ThunkResult<void> => (dispatch) => {
    const search = window.location.search;
    dispatch(setUrlParams({ urlParams: QueryStringParser.getUrlQueryObject(search) }));
};

export const setUrlParams =
    (opts: { urlParams: UrlParams }): ThunkResult<void> =>
    (dispatch, getState) => {
        if (!_.isEqual(getState().global.urlParams, opts.urlParams)) {
            dispatch({
                type: 'SET_URL_PARAMS',
                data: {
                    urlParams: opts.urlParams
                }
            });
            const urlParamsStr = QueryStringParser.getUrlQueryStr(opts.urlParams);
            const path = `${window.location.pathname}${urlParamsStr}${window.location.hash}`;
            getState().global.history?.replace(path);
        }
    };

export const setPageTitle = (opts?: { pageTitle: string }): GlobalActions => ({
    type: 'SET_PAGE_TITLE',
    data: {
        pageTitle: opts?.pageTitle?.trim() ?? ''
    }
});
